import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f4fb68d8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f4fb68d8&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fb68d8",
  null
  
)

export default component.exports